/* HeyBear · Grab a bag: the car drives in with the scroll, parks at the 7-Eleven, then drives off. */
HB.section('stores-car', function (root) {
  HB.reveal(root);
  var road = root.querySelector('#road'), car = root.querySelector('#car'), store = root.querySelector('#store'), strip = root.querySelector('#roadStrip');
  if (!road || !car) return;
  var cur = null, raf = 0;
  var clamp = function (v) { return Math.min(1, Math.max(0, v)); };
  function frame() {
    var r = road.getBoundingClientRect(), vh = innerHeight;
    /* 0 = road just entering the bottom of the screen, 1 = road leaving the top */
    var t = clamp((vh - r.top) / (vh + r.height));
    cur = cur == null || HB.reduce ? t : cur + (t - cur) * .1;
    var cw = car.offsetWidth, W = road.clientWidth, start = -cw * 1.1, park = store.offsetLeft + store.offsetWidth * .12 - cw * .35, exit = W + cw * .2;
    var A = .42, P1 = .6, B = .88; /* arrive by A, parked until P1, gone by B */
    var x, d;
    if (cur <= A) { var e = 1 - Math.pow(1 - cur / A, 2); x = start + (park - start) * e; d = e * .5; }
    else if (cur <= P1) { x = park; d = .5; }
    else { var q = clamp((cur - P1) / (B - P1)), e2 = q * q; x = park + (exit - park) * e2; d = .5 + .5 * e2; }
    car.style.transform = 'translate3d(' + x + 'px,0,0)';
    if (strip) strip.style.transform = 'translate3d(' + (-600 * d) + 'px,0,0)';
    raf = requestAnimationFrame(frame);
  }
  raf = requestAnimationFrame(frame);
  return function () { cancelAnimationFrame(raf); };
});
